<template>
	<div class="chat-autocomplete-area">
		<div ref="form" class="chat-autocomplete-form" v-show="visible">
			<ul>
				<li v-for="(item, index) in list"
					@click="$emit('applyCompletion', item)"
					@mousedown="$event.preventDefault()"
					:class="{selected: index == current}"
					>{{ item }}</li>
			</ul>
		</div>
	</div>
</template>

<script>
import eventBus from '../eventbus';
import Chat from '@chat/src/chat';
import {smileCodes} from '@chat/src/smilies';
import Vue from 'vue';

export default {
	data: () => ({
		visible: false,
		list: [],
		current: -1,
	}),

	methods: {
		// not vue
		completions(part){
			if (part.length == 0 || part[0] != '@' && part[0] != ':'){
				return [];
			}

			let type = part[0];

			if (type == '@'){
				part = part.substr(1);
				return Chat.curRoom.getMembers().filter((x) => x.name.substr(0, part.length) == part).map((x) => '@' + x.name);
			} else if (type == ':') {
				return smileCodes.filter((x) => x.substr(0, part.length) == part);
			}

			return [];
		},

		// ui interface
		setAutocompleter(obj){
			this.autocomplete = obj;
		},

		show(list){
			this.current = 0;
			this.list = list;
			this.visible = true;
			this.scrollToSelected();
		},

		hide(){
			this.visible = false;
		},

		selectNext(){
			++this.current;
			if (this.current >= this.list.length){
				this.current = 0;
			}

			this.scrollToSelected();
		},

		selectPrevious(){
			--this.current;
			if (this.current < 0){
				this.current = this.list.length - 1;
			}

			this.scrollToSelected();
		},

		getSelected(){
			return this.list[this.current];
		},

		scrollToSelected(){
			setTimeout(() => {
				if (this.current >= 0){
					let form = this.$refs.form;
					let lis = form.querySelectorAll('ul li');

					let li = lis[this.current];
					if (li.offsetTop < form.scrollTop){
						form.scrollTop = li.offsetTop;
					} else if (li.offsetTop + li.offsetHeight > form.scrollTop + form.clientHeight){
						form.scrollTop = li.offsetTop + li.offsetHeight - form.clientHeight;
					}
				}
			}, 0);
		},
	},

	created(){
		eventBus.$on('resetAutocompletion', () => {
			this.autocomplete.resetCompletionsForm();
		});
	},
}
</script>

<style lang="less" scoped>
@import (reference) "~@/css/chat.less";

.chat-autocomplete-area {
	position: relative;

	.chat-autocomplete-form {
		position: absolute;
		bottom: 0;
		padding: 10px;
		border-radius: 5px;
		background-color: @color-chat-3;
		max-height: 300px;
		overflow-y: auto;

		ul {
			padding: 0;
			margin: 0;

			li {
				padding: 5px;
				list-style: none;
				cursor: pointer;
				border-radius: 3px;

				&:hover {
					background-color: @color-chat-4;
				}

				&.selected {
					background-color: @color-chat-5;
				}
			}
		}
	}
}
</style>
